import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  CHANGE_FOLDER_CALCULS_PAGE,
  CHANGE_FOLDER_CALCULS_SEARCH,
  CHANGE_FOLDER_CALCULS_SORT,
  CHANGE_FOLDERS_PAGE,
  CHANGE_FOLDERS_SORT,
  DELETE_FOLDER,
  DELETE_FOLDER_SUCCESS,
  GET_ALL_USER_FOLDERS_FAILED,
  GET_ALL_USER_FOLDERS_SUCCESS,
  GET_ARCHIVED_CALCULS,
  GET_ARCHIVED_CALCULS_FAILED,
  GET_ARCHIVED_CALCULS_SUCCESS,
  GET_FOLDER,
  GET_FOLDER_CALCULS_FAILED,
  GET_FOLDER_CALCULS_SUCCESS,
  GET_FOLDER_FAILED,
  GET_FOLDER_SUCCESS,
  GET_USER_FOLDERS_FAILED,
  GET_USER_FOLDERS_SUCCESS,
  LOAD_ALL_USER_FOLDERS,
  LOAD_FOLDER_CALCULS,
  LOAD_USER_FOLDERS,
  MANAGE_CALCULS_FOLDERS,
  MANAGE_CALCULS_FOLDERS_FAILED,
  MANAGE_CALCULS_FOLDERS_SUCCESS,
  POST_FOLDER,
  POST_FOLDER_SUCCESS,
  UPDATE_FOLDER,
  UPDATE_FOLDER_CALCULS_FILTERS,
  UPDATE_FOLDER_CALCULS_LIMIT,
  UPDATE_FOLDER_SUCCESS,
  UPDATE_FOLDERS_LIMIT,
} from "../constants";
import { parseResponse } from "../../../utils/http";
import {
  createFolderCall,
  deleteFolderCall,
  getAllUserFoldersCall,
  getUserFoldersCall,
  getFolderCalculsCall,
  manageCalculsFoldersCall,
  updateFolderCall,
  getFolderCall,
  getArchivedCalculsCall,
} from "../../../APIClient";
import { enableFolderLoader } from "../actions";
import { toast } from "react-toastify";

function* getUserFolders() {
  const getToken = (state) => state.user.informations.token;
  const getFolderSort = (state) => state.folders.sort;
  const getFolderLimit = (state) => state.folders.limit;
  const getFolderPage = (state) => state.folders.currentPage;

  try {
    yield put(enableFolderLoader());

    const token = yield select(getToken);
    const sort = yield select(getFolderSort);
    const page = yield select(getFolderPage);
    const limit = yield select(getFolderLimit);

    const data = yield call(getUserFoldersCall, token, sort, page, limit);
    yield call(parseResponse, data, GET_USER_FOLDERS_SUCCESS);
  } catch (error) {
    yield put({ type: GET_USER_FOLDERS_FAILED, error });
  }
}

function* createFolder(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableFolderLoader());

    const data = yield call(createFolderCall, token, action.folderDatas);
    yield call(getUserFolders);
    yield call(parseResponse, data, POST_FOLDER_SUCCESS);

    yield call(toast.success, "Nouveau dossier créé");
  } catch (error) {
    yield call(toast.error, error.message);
  }
}

function* updateFolder(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableFolderLoader());

    const data = yield call(updateFolderCall, token, action.folderDatas);
    yield call(getUserFolders);
    yield call(parseResponse, data, UPDATE_FOLDER_SUCCESS);

    yield call(toast.success, "Dossier renommé");
  } catch (error) {
    yield call(toast.error, error.message);
  }
}

function* deleteFolder(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableFolderLoader());

    const data = yield call(deleteFolderCall, token, action.folderId);
    yield call(getUserFolders);
    yield call(parseResponse, data, DELETE_FOLDER_SUCCESS);

    yield call(toast.success, "Dossier supprimé");
  } catch (error) {
    yield call(toast.error, error.message);
  }
}

function* getAllUserFolders() {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    const data = yield call(getAllUserFoldersCall, token);
    yield call(parseResponse, data, GET_ALL_USER_FOLDERS_SUCCESS);
  } catch (error) {
    yield put({ type: GET_ALL_USER_FOLDERS_FAILED, error });
  }
}

function* manageCalculsFolders(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableFolderLoader());

    const data = yield call(manageCalculsFoldersCall, token, action.data);
    yield call(parseResponse, data, MANAGE_CALCULS_FOLDERS_SUCCESS);

    yield call(toast.success, "Changements enregistrés");
  } catch (error) {
    yield put({ type: MANAGE_CALCULS_FOLDERS_FAILED, error });
  }
}

function* getFolderCalculs(action) {
  const getToken = (state) => state.user.informations.token;
  const getFolderSort = (state) => state.folders.folderCalculsSort;
  const getFolderLimit = (state) => state.folders.folderCalculsLimit;
  const getFolderPage = (state) => state.folders.folderCalculsCurrentPage;
  const getSearch = (state) => state.folders.folderCalculsSearch;
  const getFilters = (state) => state.folders.folderCalculsFilters;

  try {
    const token = yield select(getToken);
    const sort = yield select(getFolderSort);
    const page = yield select(getFolderPage);
    const limit = yield select(getFolderLimit);
    const search = yield select(getSearch);
    const filters = yield select(getFilters);

    yield put(enableFolderLoader());

    const data = yield call(
      getFolderCalculsCall,
      token,
      action.folderId,
      sort,
      page,
      limit,
      search,
      filters,
    );
    yield call(parseResponse, data, GET_FOLDER_CALCULS_SUCCESS);
  } catch (error) {
    yield put({ type: GET_FOLDER_CALCULS_FAILED, error });
  }
}

function* getFolder(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableFolderLoader());

    const data = yield call(getFolderCall, token, action.folderId);
    yield call(parseResponse, data, GET_FOLDER_SUCCESS);
  } catch (error) {
    yield put({ type: GET_FOLDER_FAILED, error });
  }
}

function* getArchivedCalculs() {
  const getToken = (state) => state.user.informations.token;
  const getFolderSort = (state) => state.folders.folderCalculsSort;
  const getFolderLimit = (state) => state.folders.folderCalculsLimit;
  const getFolderPage = (state) => state.folders.folderCalculsCurrentPage;
  const getSearch = (state) => state.folders.folderCalculsSearch;
  const getFilters = (state) => state.folders.folderCalculsFilters;

  try {
    const token = yield select(getToken);
    const sort = yield select(getFolderSort);
    const page = yield select(getFolderPage);
    const limit = yield select(getFolderLimit);
    const search = yield select(getSearch);
    const filters = yield select(getFilters);

    yield put(enableFolderLoader());

    const data = yield call(
      getArchivedCalculsCall,
      token,
      sort,
      page,
      limit,
      search,
      filters,
    );
    yield call(parseResponse, data, GET_ARCHIVED_CALCULS_SUCCESS);
  } catch (error) {
    yield put({ type: GET_ARCHIVED_CALCULS_FAILED, error });
  }
}

function* getFolderOrArchivedCalculs(action) {
  try {
    yield put(enableFolderLoader());

    if (action.folderId === "archives") {
      yield call(getArchivedCalculs);
    } else {
      yield call(getFolderCalculs, action);
    }
  } catch (error) {
    yield put({
      type:
        action.folderId === "archives"
          ? GET_ARCHIVED_CALCULS_FAILED
          : GET_FOLDER_CALCULS_FAILED,
      error,
    });
  }
}

export const foldersSagas = [
  takeLatest(LOAD_USER_FOLDERS, getUserFolders),
  takeLatest(CHANGE_FOLDERS_SORT, getUserFolders),
  takeLatest(CHANGE_FOLDERS_PAGE, getUserFolders),
  takeLatest(UPDATE_FOLDERS_LIMIT, getUserFolders),
  takeLatest(POST_FOLDER, createFolder),
  takeLatest(UPDATE_FOLDER, updateFolder),
  takeLatest(DELETE_FOLDER, deleteFolder),
  takeLatest(LOAD_ALL_USER_FOLDERS, getAllUserFolders),
  takeLatest(MANAGE_CALCULS_FOLDERS, manageCalculsFolders),
  takeLatest(LOAD_FOLDER_CALCULS, getFolderCalculs),
  takeLatest(GET_FOLDER, getFolder),
  takeLatest(CHANGE_FOLDER_CALCULS_SORT, getFolderOrArchivedCalculs),
  takeLatest(CHANGE_FOLDER_CALCULS_PAGE, getFolderOrArchivedCalculs),
  takeLatest(UPDATE_FOLDER_CALCULS_LIMIT, getFolderOrArchivedCalculs),
  takeLatest(CHANGE_FOLDER_CALCULS_SEARCH, getFolderOrArchivedCalculs),
  takeLatest(GET_ARCHIVED_CALCULS, getArchivedCalculs),
  takeLatest(UPDATE_FOLDER_CALCULS_FILTERS, getFolderOrArchivedCalculs),
];
